






import { Component, Vue } from "vue-property-decorator";
import ThanksForm from "@/components/ThanksForm.vue"; // @ is an alias to /src

@Component({
  components: {
    ThanksForm
  }
})
export default class Thanks extends Vue {}
